<template>
  
  <div class="tooltip">
    <img src="@/assets/img/icons/tooltip.png" />
    <div class="box">
      {{ text }}
    </div>
  </div>

</template>

<script>

  import Vue from "vue";

  export default {

    name: "Tooltip",

    props: {
      text: String
    },

    data() {
      return {
        visible: false
      };
    },

    methods: {
      toggle() {
        this.visible = !this.visible;
      }
    }

  };

</script>

<style lang="scss" scoped>
  
  .tooltip {
    position: relative;
    cursor: pointer;
    
    &:hover {
      .box {
        display: block;
      }
    }
  }
  
  .box {
    display: none;
    position: absolute;
    transform: translateX(-40%) translateY(calc(-100% - 40px));
    background-color: #404040;
    color: white;
    border-radius: 4px;
    padding: 10px;
    text-transform: none;
    font-weight: normal;
    opacity: 0.8;
    width: 130px;
    line-height: 1.1;
    text-align: center;
    z-index: 999;
    
    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 40%;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #404040;
    }
  }

</style>

<style lang="scss">
  
  .modalContainer .tooltip .box {
    position: fixed;
  }

</style>